// UI strings for the study session (Tänään, Vapaa harjoitus): undo, the day changing, why a day is
// empty, storage problems. Finnish (default) and English side by side; en has the same shape.
// The older study strings (card, grades, end, today, free) live in fi.ts / en.ts.
import { defineArea } from '../area';

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

export const studyFi = {
  undo: 'Kumoa',
  undoLabel: 'Kumoa viimeisin arvio',
  undoHint: 'Askelpalautin tai Z',
  /** Session end: cards done, then the extra rounds of cards that came back ("again"). */
  endDaily: (cards: number, repeats: number) => `${plural(cards, 'kortti', 'korttia')} tehty${repeats ? `, ${plural(repeats, 'uusinta', 'uusintaa')}` : ''}.`,
  endFree: (cards: number, repeats: number) =>
    `Vapaata harjoitusta: ${plural(cards, 'kortti', 'korttia')}${repeats ? `, ${plural(repeats, 'uusinta', 'uusintaa')}` : ''}.`,
  practiceNote: 'Tämän sanan kertaus ei ole vielä käsillä. Vapaa harjoitus ei siirrä sitä – paitsi jos sana unohtui.',
  newDay: 'Uusi päivä on alkanut.',
  newDayStart: 'Aloita päivän kortit',
  waiting: 'Haetaan kurssin tilannetta…',
  emptyLesson: (order: number) => `Uudet sanat avautuvat, kun läpäiset oppitunnin ${order} loppukokeen.`,
  openLesson: (order: number) => `Oppitunti ${order}`,
  unsaved: (n: number) => `${n === 1 ? 'Arviota' : `${n} arviota`} ei saatu vielä tallennettua laitteelle. Yritetään uudelleen – pidä sovellus hetki auki.`,
  memoryOnly: 'Tallennus ei toimi tällä laitteella: arviot eivät säily, kun sovellus suljetaan.',
  blocked: 'Sovellus päivittyy. Sulje sen muut välilehdet tai ikkunat, niin päivitys valmistuu.',
  /** A sentence card made in the translator, removed from the session (and from the reviews). */
  removeCard: 'Poista kortti',
};

export const studyEn: typeof studyFi = {
  undo: 'Undo',
  undoLabel: 'Undo the last grade',
  undoHint: 'Backspace or Z',
  endDaily: (cards, repeats) => `${plural(cards, 'card', 'cards')} done${repeats ? `, ${plural(repeats, 'repeat', 'repeats')}` : ''}.`,
  endFree: (cards, repeats) => `Free practice: ${plural(cards, 'card', 'cards')}${repeats ? `, ${plural(repeats, 'repeat', 'repeats')}` : ''}.`,
  practiceNote: 'This word is not due yet. Free practice does not move its review – unless you forgot it.',
  newDay: 'A new day has begun.',
  newDayStart: "Start today's cards",
  waiting: 'Fetching the course state…',
  emptyLesson: (order) => `New words open when you pass the check of lesson ${order}.`,
  openLesson: (order) => `Lesson ${order}`,
  unsaved: (n) => `${n === 1 ? 'A grade has' : `${n} grades have`} not been saved on this device yet. Retrying – keep the app open for a moment.`,
  memoryOnly: 'Saving does not work on this device: grades are lost when the app is closed.',
  blocked: 'The app is updating. Close its other tabs or windows to finish.',
  removeCard: 'Remove card',
};

// Messages.study (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('study', studyFi, studyEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof studyFi> {}
}
